<template>
  <div class="forum-wrapper"
       :class="[menuList.length && 'has-footer']">
    <!-- <Foot v-if="!isShowLoading" /> -->

    <Head :lanshow="ActiveName" />
    <div class="forum-wrappers">
      <div class="forum-inner">
        <div class="nav"
             v-if="cates.length > 1">
          <span v-for="(item, index) in cates"
                :class="[item.id === currentId && 'active']"
                :key="item.id"
                @click="changeCate(item.id, index)">{{ item.name }}</span>
        </div>
        <ul v-if="list.length">
          <li v-for="item in list"
              :key="item.id">
            <router-link :to="{ path: '/forum/' + item.id, query: { lan: lang } }">
              <div class="img">
                <img :src="item.imgUrl"
                     alt="" />
              </div>
              <div class="info">
                <div class="info-inner">
                  <h4 v-html="item.name"></h4>
                  <span v-if="item.startTime">{{
                    dateRange(item.startTime, item.endTime)
                  }}</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <p class="loading-notice"
           v-if="!emptydata">
          {{
            isLoading
              ? $tc("load.loading")
              : lastList.length >= pageSize
              ? $tc("load.more")
              : $tc("load.nomore")
          }}
        </p>
        <Empty :emptydata="emptydata"
               :class="[cates.length > 1 && 'short-empty']"
               v-if="emptydata && !isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
// import Foot from '@/components/Foot.vue'

import Filters from '@/utils/filters'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Forum',
  data () {
    return {
      isLoading: false,
      cates: [],
      list: [],
      lastList: [],
      pageSize: 20,
      currentIndex: 0,
      currentId: '',
      lastDataId: '',
      emptydata: null
    }
  },
  components: {
    // Foot
  },
  computed: {
    ...mapState(['lang', 'menuList', 'isShowLoading', 'ActiveName'])
  },
  created () {
    this.getList()
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$Common.pageShare()
    })
    this.$Common.pullLoadData(this.getList)
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setToastData', 'setActiveName']),
    getList () {
      if (
        this.isLoading ||
        (this.lastDataId && this.lastList.length < this.pageSize)
      ) {
        return
      }
      this.isLoading = true
      this.$Api
        .getForumList({
          categoryId: this.currentId,
          pageSize: this.pageSize,
          lastDataId: this.lastDataId
        })
        .then(data => {
          if (data) {
            if (!this.cates.length) {
              this.cates = data.categories || []
              this.currentId =
                (this.cates.length && this.cates[0].id) || ''
              this.track()
            }
            this.list.push(...(data.forums || []))
            this.lastList = data.forums || []
            this.lastDataId = data.lastDataId || ''
          }
          if (!this.list.length) {
            this.emptydata = {
              type: 'nodata'
            }
          } else {
            this.emptydata = null
          }
          this.setShowLoading(false)
          this.isLoading = false
        })
        .catch(() => {
          if (!this.lastDataId) {
            this.emptydata = {
              type: 'nonetwork'
            }
          } else {
            this.setToastData({
              text: this.$t('default.failed')
            })
          }
          this.isLoading = false
          this.setShowLoading(false)
        })
    },
    changeCate (id, index) {
      this.currentId = id || ''
      this.currentIndex = index
      this.lastDataId = ''
      this.list = []
      this.getList()
      this.track()
    },
    // 日期格式化
    dateRange (start, end) {
      return this.lang === 'en'
        ? Filters.date.rangeMin(start, end, '/')
        : Filters.date.rangeMin(start, end, 'zh')
    },
    track () {
      this.$Common.track('load', {
        name: '云论坛列表',
        tab: this.cates[this.currentIndex].name,
        type: '云论坛'
      })
    }
  }
}
</script>

<style lang="scss">
.forum-wrappers {
  padding: 4.63vw 4.63vw 2.778vw;
  font-size: 0;
  .empty-wrapper {
    height: 60vh;
    box-sizing: border-box;
    &.short-empty {
      height: auto;
    }
  }
  &.has-footer {
    padding-bottom: 21vw;
  }
  .forum-inner {
    ul {
      padding-top: 4.63vw;
      li {
        margin-bottom: 4.63vw;
        height: 51.111vw;
        border-radius: 1.481vw;
        overflow: hidden;
        position: relative;
        a {
          display: block;
          height: 100%;
        }
        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 25vw;
          padding: 0 3.519vw;
          display: flex;
          align-items: flex-end;
          flex-wrap: wrap;
          box-sizing: border-box;
          background: linear-gradient(
            180deg,
            rgba(9, 16, 26, 0),
            rgba(9, 16, 26, 0.7)
          );
          .info-inner {
            color: #fefefe;
            padding-bottom: 2.037vw;
          }
          h4 {
            font-size: 4.074vw;
            line-height: 1.4;
            margin-bottom: 1.389vw;
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          span {
            font-size: 3.148vw;
            line-height: 1.4;
            word-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>
